__turbopack_context__.v({
  "image": "IK6uxa_image",
});
